import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Dashboard/Navbar";
import Sidebar from "../../components/Dashboard/Sidebar";
import CreateHero from "./CreateHero";
import ViewHero from "./ViewHero";
import CreateCourse from "./Course/CreateCourse";
import ViewCourses from "./Course/ViewCourses";
import CreateTestimonial from "./CreateTestimonial";
import CreateInstructor from "./CreateInstructor";
import ViewInstructors from "./ViewInstructors";
import ViewTestimonials from "./ViewTestimonials";
import ViewContacts from "./ViewContacts";
import ViewUsers from "./User/ViewUsers";
import ViewTransactions from "./ViewTransactions";
import ViewApplication from "./ViewApplication";
import CreateContactPage from "./ContactPage/CreateContactPage";
import ViewContactPage from "./ContactPage/ViewContactPage";
import CreateAboutPage from "./AboutPage/CreateAboutPage";
import ViewAboutPage from "./AboutPage/ViewAboutPage";
import CreateMembership from "./Membership/CreateMembership";
import ViewMembership from "./Membership/ViewMembership";
import CreateHome from "../Webinar/Dashboard/Home/CreateHome";
import ViewHome from "../Webinar/Dashboard/Home/ViewHome";
import CreateThank from "../Webinar/Dashboard/ThankYou/CreateThank";
import ViewThank from "../Webinar/Dashboard/ThankYou/ViewThank";
import CreateLive from "../Webinar/Dashboard/Live/CreateLive";
import ViewLive from "../Webinar/Dashboard/Live/ViewLive";
import CreateOffer from "../Webinar/Dashboard/Offer/CreateOffer";
import ViewOffer from "../Webinar/Dashboard/Offer/ViewOffer";
import CreateCongratulation from "../Webinar/Dashboard/Congratulation/CreateCongratulation";
import ViewCongratulation from "../Webinar/Dashboard/Congratulation/ViewCongratulation";
import CreateForm from "../Webinar/Dashboard/Form/CreateForm";
import ViewForm from "../Webinar/Dashboard/Form/ViewForm";
import CreateChat from "../Webinar/Dashboard/Chat/CreateChat";
import ViewChat from "../Webinar/Dashboard/Chat/ViewChat";
import CreateApi from "../Webinar/Dashboard/Api/Brevo/CreateApi";
import ViewApi from "../Webinar/Dashboard/Api/Brevo/ViewApi";
import ViewLead from "../Webinar/Dashboard/Lead/ViewLead";
import ViewTransaction from "../Webinar/Dashboard/Transaction/ViewTransaction";
import CreateService from "./Service/CreateService";
import ViewService from "./Service/ViewService";
import CreateBlog from "./Blog/CreateBlog";
import ViewBlog from "./Blog/ViewBlog";
import ViewCategory from "./Category/ViewCategory";
import CreateCategory from "./Category/CreateCategory";
import CreateLesson from "./Course/CreateLesson";
import CreateModule from "./Course/CreateModule";
import CreateSecret from "../Webinar/Dashboard/Home/Secrets/CreateSecret";
import ViewSecrets from "../Webinar/Dashboard/Home/Secrets/ViewSecrets";
import CreateBonus from "../Webinar/Dashboard/Home/Bonus/CreateBonus";
import ViewBonus from "../Webinar/Dashboard/Home/Bonus/ViewBonus";
import CreateWebinarInstructor from "../Webinar/Dashboard/Home/Instructor/CreateWebinarInstructor";
import ViewWebinarInstructor from "../Webinar/Dashboard/Home/Instructor/ViewWebinarInstructors";
import CreateProof from "../Webinar/Dashboard/Home/Proof/CreateProof";
import ViewProof from "../Webinar/Dashboard/Home/Proof/ViewProof";
import CreateCta from "../Webinar/Dashboard/Home/CTA/CreateCta";
import ViewCta from "../Webinar/Dashboard/Home/CTA/ViewCta";
import CreateFaq from "../Webinar/Dashboard/Home/FAQ/CreateFaq";
import ViewFaq from "../Webinar/Dashboard/Home/FAQ/ViewFaq";
import CreateFreeThing from "../Webinar/Dashboard/ThankYou/FreeThing/CreateFreeThing";
import ViewFreeThing from "../Webinar/Dashboard/ThankYou/FreeThing/ViewFreeThing";
import CreateFinishBonus from "../Webinar/Dashboard/ThankYou/FinishBonus/CreateFinishBonus";
import ViewFinishBonus from "../Webinar/Dashboard/ThankYou/FinishBonus/ViewFinishBonus";
import CreateCommunity from "../Webinar/Dashboard/ThankYou/Community/CreateCommunity";
import ViewCommunity from "../Webinar/Dashboard/ThankYou/Community/ViewCommunity";
import CreateJoiningInstruction from "../Webinar/Dashboard/ThankYou/Instruction/CreateJoiningInstruction";
import ViewJoiningInstructions from "../Webinar/Dashboard/ThankYou/Instruction/ViewJoiningInstructions";
import CreateAttende from "../Webinar/Dashboard/Home/Attende/CreateAttende";
import ViewAttendees from "../Webinar/Dashboard/Home/Attende/ViewAttendees";
import CreatePixel from "./Pixel/CreatePixel";
import ViewPixel from "./Pixel/ViewPixel";

const DashboardHome = () => {
  // Load selected menu from localStorage or default to dashboard
  const [selectedMenu, setSelectedMenu] = useState(
    localStorage.getItem('selectedMenu') || 'dashboard'
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      // On desktop, always show sidebar
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Save selected menu to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('selectedMenu', selectedMenu);
  }, [selectedMenu]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const renderContent = () => {
    const contentComponents = {
      courseCreate: <CreateCourse onCourseCreated={() => setSelectedMenu('courseDetails')} />,
      courseDetails: <ViewCourses />,
      membershipCreate: <CreateMembership onMembershipCreated={() => setSelectedMenu('membershipDetails')} />,
      membershipDetails: <ViewMembership />,
      serviceCreate: <CreateService onServiceCreated={() => setSelectedMenu('serviceDetails')} />,
      serviceDetails: <ViewService />,
      moduleCreate: <CreateModule onModuleCreated={() => setSelectedMenu('moduleDetails')} />,
      moduleDetails: <ViewCourses />,
      lessonCreate: <CreateLesson onLessonCreated={() => setSelectedMenu('lessonDetails')} />,
      lessonDetails: <ViewCourses />,
      heroCreate: <CreateHero onHeroCreated={() => setSelectedMenu('heroOverview')} />,
      heroOverview: <ViewHero />,
      testimonialCreate: <CreateTestimonial onTestimonialCreated={() => setSelectedMenu('testimonialOverview')} />,
      testimonialOverview: <ViewTestimonials />,
      instructorCreate: <CreateInstructor onInstructorCreated={() => setSelectedMenu('instructorOverview')} />,
      instructorOverview: <ViewInstructors />,
      contactPageCreate: <CreateContactPage onContactPageCreated={() => setSelectedMenu('contactPageOverview')} />,
      contactPageOverview: <ViewContactPage />,
      aboutPageCreate: <CreateAboutPage onAboutPageCreated={() => setSelectedMenu('aboutPageOverview')} />,
      aboutPageOverview: <ViewAboutPage />,
      blogCreate: <CreateBlog onBlogCreated={() => setSelectedMenu('blogOverview')} />,
      blogOverview: <ViewBlog />,
      categoryCreate: <CreateCategory onCategoryCreated={() => setSelectedMenu('categoryOverview')} />,
      categoryOverview: <ViewCategory />,
      contact: <ViewContacts />,
      transactions: <ViewTransactions />,
      users: <ViewUsers />,
      applications: <ViewApplication />,


      createHome: <CreateHome onHomeCreated={() => setSelectedMenu('homeOverview')} />,
      homeOverview: <ViewHome />,
      createSecret: <CreateSecret onSecretCreated={() => setSelectedMenu('secretOverview')} />,
      secretOverview: <ViewSecrets />,
      createBonus: <CreateBonus onBonusCreated={() => setSelectedMenu('bonusOverview')} />,
      bonusOverview: <ViewBonus />,
      createWebinarInstructor: <CreateWebinarInstructor onWebinarInstructorCreated={() => setSelectedMenu('webinarInstructorOverview')} />,
      webinarInstructorOverview: <ViewWebinarInstructor />,
      createSocialProof: <CreateProof onSocialProofCreated={() => setSelectedMenu('socialProofOverview')} />,
      socialProofOverview: <ViewProof/>,
      createWebinarCta: <CreateCta onWebinarCtaCreated={() => setSelectedMenu('webinarCtaOverview')} />,
      webinarCtaOverview: <ViewCta/>,
      createWebinarFaq: <CreateFaq onWebinarFaqCreated={() => setSelectedMenu('webinarFaqOverview')} />,
      webinarFaqOverview: <ViewFaq />,
      createAttende: <CreateAttende onAttendeeCreated={() => setSelectedMenu('attendeOverview')} />,
      attendeOverview: <ViewAttendees />,

      createThank: <CreateThank onThankCreated={() => setSelectedMenu('thankOverview')} />,
      thankOverview: <ViewThank />,
      createFreeThing: <CreateFreeThing onFreeThingCreated={() => setSelectedMenu('freethingOverview')} />,
      freethingOverview: <ViewFreeThing />,
      createFinishBonus: <CreateFinishBonus onFinishBonusCreated={() => setSelectedMenu('finishBonusOverview')} />,
      finishBonusOverview: <ViewFinishBonus />,
      createCommunity: <CreateCommunity onCommunityCreated={() => setSelectedMenu('communityOverview')} />,
      communityOverview: <ViewCommunity />,
      createJoiningInstruction: <CreateJoiningInstruction onJoiningInstructionCreated={() => setSelectedMenu('joiningInstructionOverview')} />,
      joiningInstructionOverview: <ViewJoiningInstructions />,

      createLive: <CreateLive onLiveCreated={() => setSelectedMenu('liveOverview')} />,
      liveOverview: <ViewLive />,
      createOffer: <CreateOffer onOfferCreated={() => setSelectedMenu('offerOverview')} />,
      offerOverview: <ViewOffer />,
      createCongrates: <CreateCongratulation onCongratesCreated={() => setSelectedMenu('congratesOverview')} />,
      congratesOverview: <ViewCongratulation />,
      createForm: <CreateForm onFormCreated={() => setSelectedMenu('formOverview')} />,
      formOverview: <ViewForm />,
      createChat: <CreateChat onChatCreated={() => setSelectedMenu('chatOverview')} />,
      chatOverview: <ViewChat />,
      createBrevoApi: <CreateApi onBrevoApiCreated={() => setSelectedMenu('brevoApiOverview')} />,
      brevoApiOverview: <ViewApi />,
      createPixel: <CreatePixel onPixelCreated={() => setSelectedMenu('pixelOverview')} />,
      pixelOverview: <ViewPixel />,
      leadOverview: <ViewLead />,
      transactionOverview: <ViewTransaction />,
    };

    return contentComponents[selectedMenu] || (
      <div className="p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Welcome to the Dashboard</h1>
        <p className="text-gray-600">Select an option from the sidebar to get started.</p>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <DashboardCard 
            icon="📊" 
            title="Analytics" 
            description="View your dashboard analytics and statistics"
          />
          <DashboardCard 
            icon="📝" 
            title="Quick Actions" 
            description="Create new content or manage existing items"
          />
          <DashboardCard 
            icon="🔔" 
            title="Notifications" 
            description="Check your recent notifications and alerts"
          />
        </div>
      </div>
    );
  };

  const DashboardCard = ({ icon, title, description }) => (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
      <div className="text-2xl mb-2">{icon}</div>
      <h3 className="font-semibold text-gray-800">{title}</h3>
      <p className="text-sm text-gray-600 mt-1">{description}</p>
    </div>
  );

  return (
    <div className="flex flex-col md:flex-row h-screen bg-gray-50">
      {/* Navbar */}
      <Navbar 
        toggleSidebar={toggleSidebar} 
        navigate={navigate} 
        isMobile={isMobile}
        isSidebarOpen={isSidebarOpen}
      />

      {/* Sidebar */}
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        selectedMenu={selectedMenu}
        setSelectedMenu={setSelectedMenu}
        toggleSidebar={toggleSidebar}
        navigate={navigate}
        isMobile={isMobile}
      />

      {/* Main Content */}
      <main className={`flex-1 overflow-auto transition-all duration-300 ${isSidebarOpen ? 'ml-0 md:ml-10' : 'ml-0'}`}>
        <div className="flex items-center justify-center p-4 md:p-6 md:mt-24">
          <div className="bg-white rounded-lg shadow-sm p-4 md:p-6 w-full">
            {renderContent()}
          </div>
        </div>
      </main>

      {/* Overlay for mobile sidebar */}
      {isSidebarOpen && isMobile && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20"
          onClick={toggleSidebar}
        />
      )}
    </div>
  );
};

export default DashboardHome;